module.exports = __webpack_public_path__ + "img/option_icon.eef1bc1d.svg";